import { useAuth } from '@clerk/clerk-react';

import { setTokenGetter } from '@/lib/api-client';

export function ApiTokenInitializer({ children }: { children: React.ReactNode }) {
  const { getToken } = useAuth();

  // Set synchronously during render so it's available before children's effects fire
  setTokenGetter(getToken);

  return <>{children}</>;
}
